// Lightweight dismissible alert — replaces the .NET TempData flash banner.
//
// The 700px cap + centering lives in CSS (.app-alert) rather than an inline
// style so the admin shell can widen it to its content column: inside a wide
// column a centred 700px box reads as detached and shifts layout when it
// appears (docs/ADMIN_REFACTOR_BRIEF.md §5.8). Non-admin pages keep the cap.

export default function Alert({ kind = 'danger', children, onClose }) {
  return (
    <div
      className={`alert alert-${kind} alert-dismissible fade show app-alert`}
      role="alert"
    >
      {children}
      {onClose && (
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        />
      )}
    </div>
  );
}
